<template>
	<div class="user_feedback_reply clearfix p_background">
		<h3 class="all_title clearfix">
			<span>用户反馈</span>
			<router-link to="/feedback_list" class="pull-right cursor color_9 th3">返回</router-link>
		</h3>

		<section class="all_container container_box">

			<div class="detail">
				<section class="title th2 color_6">反馈内容</section>
				<section class="content">
					<div class="top clearfix color_9 clearfix">
						<span class="item">
							反馈人：{{feedback.schoolcloudUserUsername}}
						</span>
						<span class="item text-center">
							反馈类型：
							<span v-if="feedback.feedbackType == '1'">平台反馈</span>
							<span v-if="feedback.feedbackType == '2'">意见建议</span>
							<span v-if="feedback.feedbackType == '3'">应用反馈<span v-if="feedback.appName != null">-{{feedback.appName}}</span></span>
						</span>
						<span class="item text-right">
							反馈时间：{{feedback.feedbackTime | datetime}}
						</span>
					</div>
					<div class="bottom">
						<section class="text_show color_9">
							{{feedback.feedbackComment}}
						</section>
						<section class="imgFile color_308de2" v-if="feedbackFiles != null">
							<img :src="feedbackFiles.filePath" alt="反馈图片"/>
						</section>
					</div>
				</section>
			</div>

			<div class="detail">
				<section class="title th2 color_6">反馈回复</section>
				<section class="content reply">
					<div class="top clearfix color_3">
						<span>变更反馈类型：</span>
						<select class="form-control form_select" v-model="feedbackType">
							<option value="1">平台反馈</option>
							<option value="2">意见建议</option>
							<option value="3">应用反馈</option>
						</select>
						<select v-model="feedbackNext" class="form-control form_select" v-if="feedbackType == 3">
							<option value="">请选择应用</option>
							<option v-for="item in appList" :label="item.viewName" :value="item.id"></option>
						</select>
					</div>
					<div class="bottom">
						<section class="text_show color_9">
							<textarea v-model="answerComment" class="text_control" placeholder="输入回复内容"></textarea>
						</section>
					</div>
				</section>
				<section class="btn_box text-right">
					<button class="btn btn_issue" @click="saveData()">回复</button>
				</section>
			</div>

		</section>
	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'
	export default {
		data() {
			return {
				feedbackId: this.$route.params.feedbackId,
				feedback:'',
				feedbackType: '1',
				answerComment: '',
				appList:[],
				feedbackNext: '',
				feedbackFiles:[]
			}
		},
		mounted: function() {
			this.$nextTick(function() {

			})
		},
		// 页面初始化
		created: function() {
			this.initData();
			this.initData1();
		},
		methods: {
			initData() {
				var _this = this;
				this.$http.post('/zklccloud/queryFeedbackInfoById', { "id": this.feedbackId}, { emulateJSON: true }).then(function(m) {
					_this.feedback = m.body.content.feedback;
					_this.feedbackFiles = m.body.content.feedbackFiles;
				})
			},
			initData1() {
				var _this = this;
				this.$http.post('/zklccloud/queryAppsList', { emulateJSON: true }).then(function(m) {
					_this.appList = m.body.content.appList
				})
			},
			saveData() {
				var temp = this;
				
				var feedbackType = temp.feedbackType;
				var feedbackNext = temp.feedbackNext;
				var answerComment = temp.answerComment;
				if(feedbackType == '3'){
					if(feedbackNext == ''){
						MessageBox('请选择变更应用反馈的应用', '提示', 'warning', {
							confirmButtonText: '确定',
						})
						return
					}
				}
				
				if(answerComment.trim() == '') {
					MessageBox('请输入回复内容', '提示', 'warning', {
						confirmButtonText: '确定',
					})
					return
				}
				
				this.$http.post('/zklccloud/updateFeedbackInfo', { "id": this.feedbackId,"feedbackType": feedbackType,"appid": feedbackNext,"answerComment": answerComment }, { emulateJSON: true }).then(function(m) {
					temp.$router.push({ path: '/feedback_list' });
				})
			},
		}
	}
</script>

<style scoped>
	.title {
		padding: 15px 0;
	}
	
	.content {
		border: 1px dashed #ccc;
		margin-bottom: 15px;
	}
	
	.reply {
		border-color: #2F8EE2;
	}
	
	.reply .top {
		border-color: #2F8EE2;
	}
	
	.top {
		padding: 10px 15px;
		border-bottom: 1px dashed #ccc;
	}
	
	.top .item {
		float: left;
		width: 25%;
	}
	
	.bottom {
		padding: 10px 15px;
	}
	
	.text_show {
		min-height: 120px;
		margin-bottom: 15px;
	}
	
	.imgFile {
		width: 100%;
	}
	
	.imgFile img {
		max-width: 100%;
	}
	
	.form_select {
		display: inline-block;
		width: auto;
		height: 30px;
		padding: 2px 12px;
	}
	
	.btn_box {
		margin-bottom: 15px;
	}
	
	.text_control {
		width: 100%;
		max-width: 100%;
		min-width: 100%;
		height: 140px;
		min-height: 140px;
		max-height: 140px;
		padding: 10px;
		border: 0 none;
		outline: none;
	}
</style>


// WEBPACK FOOTER //
// reply.vue?38b8dcc3